"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var antd_1 = require("antd");
var Content = antd_1.Layout.Content;
exports.default = styled_components_1.default(Content)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  padding: 20px;\n  border-top: 1px solid #dfdfdf;\n  position: relative;\n"], ["\n  padding: 20px;\n  border-top: 1px solid #dfdfdf;\n  position: relative;\n"])));
var templateObject_1;
//# sourceMappingURL=index.js.map